<template>
  <div class="related_message">
    <el-tabs v-if="cmsNode" v-model="childCode" type="border-card">
      <el-tab-pane v-for="tab in cmsNode.nodeData" :key="tab.nodeInfoVo.id" :label="tab.nodeInfoVo.name" :name="tab.nodeInfoVo.code">

        <div v-if="!nodeChildArticles || !nodeChildArticles.length" style="height:100%" class="x_y_center">
          <img src="@/assets/images/empty_icon.png" alt="">
          <span style="margin:0 0 0 10px" class="fz14">暂无数据</span>
        </div>

        <div v-for="item in nodeChildArticles" v-else :key="item.id" class="div_1  d_flex justify_content_sb fz14" @click="onLinkClick(tab,item)">
          <div class="d_flex align_item_c">
            <span class="span_1" />
            <span class="span_2  text_ellipsis c_1A1A1A">{{ item.title }}</span>
          </div>
          <span class="c_808080">{{ formatDate( new Date(tranTimeFormat(item.createdAt)) ,'yyyy-MM-dd') }}</span>
        </div>

      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import { mapGetters, mapActions } from 'vuex'
import { formatDate } from '@/utils'
import { cms_article_list } from '@/api/portal'
export default {

  data() {
    return {
      childCode: 'dtnews', // 文章code
      cmsNode: null, // 栏目
      cmsNodeChlid:null, // 子栏目
      nodeChildArticles: [], // 文章数据
    }
  },
  computed: {
    ...mapGetters(['nodeSubsets']),

    formatDate() {
      return function(date, fmt) {
        return formatDate(date, fmt)
      }
    },

    tranTimeFormat() {
      return function(dateStr) {
        return dateStr.replace(/-/g, '/')
      }
    }
  },
  watch: {
    async childCode(n, o) {
      const { data } = await cms_article_list({ code: n, rows: 6 })
      this.nodeChildArticles = data.list
      this.cmsNodeChlid = this.cmsNode.nodeData.find(i=>i.nodeInfoVo.code === n).nodeInfoVo
      this.$emit('chlidNodeChange',this.cmsNodeChlid)
    },
    nodeSubsets:{
      handler(n){
        if(n.length){
          this.cmsNode = this.nodeSubsets.find(i => i.code === 'news')
          this.cmsNodeChlid = this.cmsNode.nodeData[0].nodeInfoVo
          this.nodeChildArticles = this.cmsNode.nodeData[0].articles
          this.$emit('chlidNodeChange',this.cmsNodeChlid)
        }
      },
      immediate:true
    }
  },
  created() {
  },

  methods: {
    // 链接点击
    onLinkClick(tab,item) {
      Cookies.set('cmsNodeId', this.cmsNode.id)
      Cookies.set('cmsNodeChlidId', tab.nodeInfoVo.id)
      this.$router.push(`${tab.nodeInfoVo.infoModel.route}/${item.id}`)
    },

  }
}
</script>

<style lang="scss" scoped>
.related_message {
  width: 438px;
  .div_1{
    margin: 0 0 18px 0;
        cursor: pointer;

    &:hover{
      .span_2{
        text-decoration: underline;
      }
    }
  }
  .span_1 {
    display: inline-block;
    width: 6px;
    height: 6px;
    background: #3084cf;
    border-radius: 50%;
  }
  .span_2{
    display: inline-block;
    width: 268px;
    margin: 0 0 0 5px;

  }
}

.related_message ::v-deep   .el-tabs__item{
  font-size: 14px;
}
.related_message ::v-deep .el-tab-pane{
  height: 100%;
}
.related_message ::v-deep  .el-tabs__content{
    height: 237px;
    box-sizing: border-box;
    border: 1px solid #DCDFE6;
    border-right: 0;
  }
.related_message ::v-deep   .el-tabs__item:first-child{
    margin: 0!important;
}
.related_message ::v-deep   .el-tabs__item:hover{
    color: #1a1a1a !important;
}
.related_message ::v-deep  .el-tabs--border-card>.el-tabs__header{
  background-color: #f5f5f5;
  border: 0;
}
.related_message ::v-deep .el-tabs--border-card{
  box-shadow: none;
  border: 0;
}
.related_message ::v-deep  .el-tabs__nav{
  .is-active{
    font-weight: bold;
    color: #1a1a1a;
    border-top: 1px solid #DCDFE6 !important;
  }
}

</style>
